import { Component, VectorImageData } from '@wix/thunderbolt-becky-types'
import { createCompNode } from '@wix/thunderbolt-catharsis'
import { getFontFamilyFontsFromSvg } from '@wix/thunderbolt-commons'
import { ResolvedSvgDataItem } from '../../../types'
import { EMPTY_ARRAY } from '../../../utils/constants'
import { FeatureRefs } from '../../cssFeatures.types'

export const vectorImageFontFamilies = {
	predicate: (component: Component) => component.componentType === 'VectorImage',
	compNode: createCompNode({
		getDependencies: (component: Component, refs: FeatureRefs<'fontFaces'>) =>
			refs.dataQuery<ResolvedSvgDataItem<VectorImageData>>(component.dataQuery!),
		toViewItem: (__, compData) => {
			return compData?.resolvedSvg
				? getFontFamilyFontsFromSvg(compData.resolvedSvg.content).flatMap((x) => x)
				: EMPTY_ARRAY
		},
	}),
}
